const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://www.wooriexpress.co.kr';

const movingCompanySchema = {
  '@context': 'https://schema.org',
  '@type': 'MovingCompany',
  name: '우리집익스프레스',
  legalName: '철원글로벌물류',
  telephone: '0507-1366-2424',
  url: `${siteUrl}/`,
  description:
    '강원도·수도권 포장이사·원룸이사·사무실이사·장거리이사 전문 직영업체. 외주 없는 100% 직영 운영으로 합리적인 가격과 완벽한 서비스를 제공합니다.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '호국로 4184',
    addressLocality: '포천시 영북면',
    addressRegion: '경기도',
    postalCode: '11161',
    addressCountry: 'KR',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 37.8947,
    longitude: 127.2004,
  },
  areaServed: [
    { '@type': 'State', name: '강원도' },
    { '@type': 'State', name: '경기도' },
    { '@type': 'City', name: '서울특별시' },
    { '@type': 'City', name: '인천광역시' },
  ],
  serviceType: ['구리포장이사', '포장이사', '원룸이사', '사무실이사', '장거리이사', '강원도이사', '수도권이사'],
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '08:00',
      closes: '20:00',
    },
  ],
  priceRange: '₩₩',
  sameAs: [],
};

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: '우리집익스프레스',
  image: `${siteUrl}/og-image.jpg`,
  telephone: '0507-1366-2424',
  url: `${siteUrl}/`,
  address: {
    '@type': 'PostalAddress',
    streetAddress: '호국로 4184',
    addressLocality: '포천시 영북면',
    addressRegion: '경기도',
    postalCode: '11161',
    addressCountry: 'KR',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 37.8947,
    longitude: 127.2004,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '08:00',
      closes: '20:00',
    },
  ],
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5.0',
    reviewCount: '200',
    bestRating: '5',
    worstRating: '1',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '포장이사 비용은 얼마인가요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '이사 규모(원룸·투룸·아파트 등)와 거리에 따라 달라집니다. 정확한 견적은 무료 방문 견적 또는 전화 상담(0507-1366-2424)을 통해 확인하실 수 있습니다.',
      },
    },
    {
      '@type': 'Question',
      name: '장거리 이사도 가능한가요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '네, 전국 어디든 직영팀이 직접 이동합니다. 강원도·수도권 외 지역도 장거리 이사 서비스를 제공합니다.',
      },
    },
    {
      '@type': 'Question',
      name: '외주 업체를 사용하나요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '아니요. 우리집익스프레스는 100% 직영 운영 체계로, 외주 없이 동일한 팀이 처음부터 끝까지 책임집니다.',
      },
    },
    {
      '@type': 'Question',
      name: '사무실 이사도 가능한가요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '네, 소규모 사무실부터 대형 사무실까지 사무실 이사 서비스를 제공합니다. 업무 공백을 최소화하도록 일정을 조율해 드립니다.',
      },
    },
    {
      '@type': 'Question',
      name: '견적은 어떻게 받나요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '홈페이지 견적 신청 폼을 작성하시거나 전화(0507-1366-2424)로 문의하시면 빠르게 안내해 드립니다. 무료 방문 견적도 가능합니다.',
      },
    },
  ],
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '우리집익스프레스 | 강원도·수도권 , 구리.의정부 포장이사 직영 전문업체',
  description:
    '우리집익스프레스는 강원도·수도권(서울·경기·인천) 포장이사·원룸이사·사무실이사·장거리이사 전문 직영업체입니다. 외주 없는 100% 직영 운영으로 합리적인 가격과 완벽한 서비스를 제공합니다. 전국 어디든 직접 갑니다. ☎ 0507-1366-2424',
  url: `${siteUrl}/`,
  inLanguage: 'ko-KR',
  isPartOf: {
    '@type': 'WebSite',
    name: '우리집익스프레스',
    url: `${siteUrl}/`,
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '홈',
        item: `${siteUrl}/`,
      },
    ],
  },
};

const schemas = [movingCompanySchema, localBusinessSchema, faqSchema, webPageSchema];

export default function SeoJsonLd() {
  return (
    <>
      {schemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}
